import React, { FC } from 'react';

import { House } from '@r1-frontend/ui-react/components/svg/building';
import { Electricity } from '@r1-frontend/ui-react/components/svg/devices';
import { CalendarSecond, Clock } from '@r1-frontend/ui-react/components/svg/time';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import ListItemWithIcon from '@r1-frontend/ui-react/organisms/ListItemWithIcon';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import InfoBlock from '~/src/features/full-buy/InfoBlock';

interface IProps {
    date?: string,
    sla?: string,
    isInstallationHardware: boolean,
}

const EmployeeVisitInfo: FC<IProps> = ({ date, sla, isInstallationHardware }) => {
    return (
        <InfoBlock header={'Визит инженера'}>
            <ListItemWithIcon
                isBiggerFont={true}
                Icon={CalendarSecond}
                title={'Когда придёт:'}
                value={date}
            />
            <ListItemWithIcon
                isBiggerFont={true}
                Icon={Electricity}
                title={'Что будет делать:'}
                value={
                    (<Paragraph4 $color={COLORS.TextPrimary} $smaller={false}>
                        Просверлит отверстие между квартирой и подъездом и проложит кабель.<br/>
                        Если интернет-кабель в квартире уже есть — проверит его и заменит при необходимости.<br/>
                        Настроит оборудование и покажет, как всё работает. А ещё поможет оплатить услуги через сайт или мобильное приложение «Мой
                        Дом.ру».
                    </Paragraph4>)
                }
            />
            <ListItemWithIcon
                isBiggerFont={true}
                Icon={House}
                title={'Как подготовиться:'}
                value={`${isInstallationHardware ? 'Выберите и освободите место для роутера или ТВ-приставки.' : ''}
                Держите под рукой паспорт, логин и пароль от Госуслуг для оформления электронного договора. Убедитесь, что ваши телевизор, компьютер или ноутбук исправны. Заранее пополните баланс на карте — оплатить услуги можно только онлайн на сайте или через мобильное приложение.`}
            />
            <ListItemWithIcon
                isBiggerFont={true}
                Icon={Clock}
                value={'Все работы займут около ' + sla + '.'}
            />
        </InfoBlock>
    );
};

export default EmployeeVisitInfo;
